import { Grid, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export type DetailsRow = { label: string; value: ReactNode };

type Props = {
  details: DetailsRow[];
  label: string;
};
const ReviewDetailsGrid: React.FC<Props> = ({ label, details }: Props) => {
  return (
    <Grid item container spacing={3} role="list" aria-label={label}>
      {details.map(({ label, value }, idx) => (
        <Grid
          key={label + '-' + idx}
          item
          container
          justifyContent="space-between"
          role="listitem"
          direction="row"
          wrap="nowrap"
        >
          <Grid item component="label" id={`${label}-label`} maxWidth="75%">
            <Typography variant="body2" color="textSecondary">
              {label}
            </Typography>
          </Grid>
          <Grid item aria-labelledby={`${label}-label`}>
            <Typography variant="body2" component="div" align="right">
              {value}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export { ReviewDetailsGrid };
